import React, { FC, useState } from 'react'
import { Button, Stack, Text, theme } from '@lojinha/design-system'
import { testId } from '@lojinha/helpers'
import copy from 'copy-to-clipboard'
import {
  CheckCircleOutline,
  Copy as IconCopy,
} from '@lojinha/design-system/src/icons'
import { beholder } from '@lojinha/beholder'
import { t } from '../../dictionary'

type Props = {
  code: string
  ariaLabel?: string
}

export const CopyButton: FC<Props> = ({ code, ariaLabel }) => {
  const [hasCodeCopied, setHasCodeCopied] = useState(false)

  const onCodeCopied = () => {
    beholder.shot('structuredEvent', {
      category: 'customer_referral',
      action: 'copy_coupon',
      label: 'referral_page',
    })

    copy(code)
    setHasCodeCopied(true)
  }

  return (
    <Button
      size="large"
      ariaLabel={ariaLabel}
      onClick={onCodeCopied}
      htmlAttrs={{ style: { width: '100%' } }}
      {...testId('button-copy-code')}
    >
      <Stack
        layout="horizontal"
        margin="x8"
        htmlAttrs={{
          style: { justifyContent: 'space-between', height: theme.space.x24 },
        }}
      >
        <Text isBold textSize="x12">
          {code}
        </Text>
        <Stack layout="horizontal" margin="x8">
          {hasCodeCopied ? (
            <div {...testId('check-outline-icon')}>
              <CheckCircleOutline size="x20" />
            </div>
          ) : (
            <>
              <Text isBold textSize="x12">
                {t.copy}
              </Text>
              <IconCopy size="x20" />
            </>
          )}
        </Stack>
      </Stack>
    </Button>
  )
}
